// extracted by mini-css-extract-plugin
export default {"ElevatedCard":"ElevatedCard_ElevatedCard__AxKac","background":"ElevatedCard_background__X+CA6","outline":"ElevatedCard_outline__IrbPh","content":"ElevatedCard_content__pMtRE"};